import React from "react";
import { Icon, Collapse, Slider } from "@blueprintjs/core";
import { Translate } from "react-redux-i18n";
import CircleImage from "../../components/Image/CircleImage";
import FormatedPrice from "../../components/FormatedPrice";
import { updateProduct, nextPage, previousPage, setGroupType } from "../../store/b2b_button/creators";
import { getB2BProduct } from "../../store/b2b_button/selectors";
import { connect } from "react-redux";
import Div100vh from "react-div-100vh";
import CustomIcon from "../../components/CustomIcon";
import ReactGA from "react-ga";

class Page2 extends React.Component {
  changeMembersNumber = value => {
    this.props.updateProduct({ suggested_members_no: value });
  };

  startGroupe = type => {
    this.props.setGroupType(type);
    this.props.nextPage();
    ReactGA.event({
      category: "B2B widget",
      action: "Clicked go to page 3"
    });
  };
  state = {
    isOpen: false
  };

  toggleProductInfo = () => this.setState({ isOpen: !this.state.isOpen });

  render() {
    const { previousPage, product } = this.props;
    return (
      <Div100vh className="b2b-100vh-container">
        <div className="b2b-container">
          <div className="back-button" onClick={_ => previousPage()}>
            <Icon icon="arrow-left" className="icon" />
            <Translate value="b2b.go_back" />
          </div>
          <div className="main-content-wrapper top-align full-height">
            <div className="product-info trigger-collapse" onClick={this.toggleProductInfo}>
              <div className="product-image">
                <CircleImage src={product.images[0].url} size="medium" alt={product.name} />
              </div>
              <div className="product-meta">
                <div className="product-name">{product.name}</div>
                <div className="product-meta-helper">
                  <Translate value="b2b.members_no_helper" members_no={product.suggested_members_no} />
                  <FormatedPrice
                    value={parseFloat(product.total_price) / parseInt(product.suggested_members_no)}
                    currency_type={product.currency}
                  />
                  <Translate value="b2b.change_members_no" />
                </div>
              </div>
            </div>
            <Collapse isOpen={this.state.isOpen} className="co-owner-collapse">
              <div className="product-owner-split">
                <div className="owner-split">
                  <div className="owner-split-item owner-info">
                    <div className="number">{product.suggested_members_no}</div>
                    <div className="label">
                      <Translate value="b2b.co_owners" />
                    </div>
                  </div>
                  <div className="owner-split-item price-info">
                    <div className="previous-number">{product.total_price}</div>
                    <div className="number">
                      <FormatedPrice
                        value={parseFloat(product.total_price) / parseInt(product.suggested_members_no)}
                        currency_type={product.currency}
                      />
                    </div>
                    <div className="label">
                      <Translate value="b2b.per_owner" />
                    </div>
                  </div>
                </div>
                <Slider
                  min={2}
                  max={100}
                  stepSize={1}
                  labelStepSize={5}
                  labelRenderer={true}
                  value={product.suggested_members_no}
                  showTrackFill={true}
                  onChange={this.changeMembersNumber}
                  className="product-slider"
                />
                <hr />
              </div>
            </Collapse>
            <h1>
              <Translate value="b2b.what_kind_of_group" />
            </h1>
            <p>
              <Translate value="b2b.what_kind_of_group_note" />
            </p>

            <div className="start-group-cta" onClick={_ => this.startGroupe("private")}>
              <CustomIcon name="add-users" className="cta-icon" size="48" />
              <div className="copy">
                <strong>
                  <Translate value="b2b.start_friend_group" /> <CustomIcon name="chevron" className="icon" size="24" />
                </strong>
                <p>
                  <Translate value="b2b.start_friend_group_copy" />
                </p>
              </div>
            </div>

            <div className="start-group-cta" onClick={_ => this.startGroupe("public")}>
              <CustomIcon name="world-location" className="cta-icon" size="48" />
              <div className="copy">
                <strong>
                  <Translate value="b2b.start_public_group" /> <CustomIcon name="chevron" className="icon" size="24" />
                </strong>
                <p>
                  <Translate value="b2b.start_public_group_copy" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </Div100vh>
    );
  }
}

const mapStateToProps = state => ({
  product: getB2BProduct(state)
});

const mapDispatchToProps = {
  updateProduct,
  nextPage,
  previousPage,
  setGroupType
};

export default connect(mapStateToProps, mapDispatchToProps)(Page2);
